import {defineStore} from 'pinia';
import {useChatStore} from "@/modules/chat/stores/chatStore";
import {useAppStateStore} from "@/modules/chat/stores/appStore";

export const useInputStore = defineStore('input', {
    state: () => ({
        selectedPreset: '',
        selectedModel: '',
        inputValue: '',
        system_prompt: '',
        selectedUmlMode: '',
        searchDomainFilter: '',
        musicTitle: '',
        musicTags: '',
        webSearch: false,
    }),
    actions: {
        resetInputValue() {
            this.inputValue = '';
        },
        selectPreset(preset) {
            this.selectedPreset = preset;
        },
        selectModel(model) {
            this.selectedModel = model;
        },
        selectUmlMode(umlMode) {
            this.selectedUmlMode = umlMode;
        },
        async changePresetHandle() {
            const {dialog, patchDialog} = useChatStore();
            const {selectedPreset, selectModel} = this;
            if (selectedPreset) {
                const oldMode = useAppStateStore().mode;
                useAppStateStore().setModeByPreset(selectedPreset);
                if (oldMode !== useAppStateStore().mode) {
                    const newModel = useAppStateStore().getDefaultModel();
                    await selectModel(newModel);
                    if (dialog) {
                        await patchDialog(dialog.id, {
                            system_prompt: selectedPreset.system_prompt,
                            mode: selectedPreset.key,
                            model: this.selectedModel.id
                        });
                    }
                    await useAppStateStore().setAttachFiles(selectedPreset.can_attach_files);
                }
            }
        }
    }
});